import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';

interface CanonicalUrlProps {
  path?: string; // Optional override for the path
}

/**
 * Adds a canonical URL tag to the page head.
 * Uses data-aviator.com (with hyphen) as the canonical domain for SEO consistency.
 */
export const CanonicalUrl = ({ path }: CanonicalUrlProps) => {
  const location = useLocation();
  const canonicalPath = path ?? location.pathname;
  const baseUrl = 'https://data-aviator.com';
  
  // Ensure path starts with / and remove trailing slash (except for root)
  const normalizedPath = canonicalPath === '/' 
    ? '' 
    : canonicalPath.replace(/\/$/, '');
  
  const canonicalUrl = `${baseUrl}${normalizedPath}`;

  return (
    <Helmet>
      <link rel="canonical" href={canonicalUrl} />
    </Helmet>
  );
};
